import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useApp } from '../context';
import { api, errorText } from '../api';
import { useFormFields } from '../hooks/useFormFields';

function validQuantity(item, sample) {
  return Number.isInteger(item.quantity) && item.quantity >= (sample ? 1 : item.moq);
}

export function useRFQBuilder() {
  const { user, draft, setDraft } = useApp();
  const [params] = useSearchParams();
  const [step, setStep] = useState(0);
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);
  const fields = useFormFields({
    destination: '', state_code: user?.state_code || '27', pincode: '',
    timeline: 'Within 2 weeks', notes: '', sample: params.get('sample') === 'true',
  });
  const validItems = draft.length > 0 && draft.every(item => validQuantity(item, fields.form.sample));
  const setQuantity = (productId, quantity) => setDraft(current => current.map(item =>
    item.product_id === productId ? { ...item, quantity } : item));
  const removeItem = productId => setDraft(current => current.filter(item => item.product_id !== productId));

  async function submit(event) {
    event.preventDefault();
    setError('');
    if (step < 2) { setStep(current => current + 1); return; }
    setBusy(true);
    try {
      const { data } = await api.post('/rfqs', {
        ...fields.form,
        items: draft.map(({ product_id, quantity }) => ({ product_id, quantity })),
        attachment_ids: files.map(file => file.id),
      });
      setDone(data);
      setDraft([]);
      toast.success('Your request has been sent');
    } catch (requestError) {
      setError(errorText(requestError));
    } finally { setBusy(false); }
  }

  return { user, draft, ...fields, step, setStep, files, setFiles, busy, error, done,
    validItems, setQuantity, removeItem, submit };
}